import { ProfileWizard } from '@/modules/recruits/components';

const CustomOnboarding = () => (
  <div className="grow flex items-center justify-center bg-gray-500 py-7">
    <ProfileWizard />
  </div>
);

export default CustomOnboarding;
